import React from "react";

function UploadBox({ openFileDialog, illustration }) {
  return (
    <div className="upload-box">
      <img src={illustration} alt="Upload Illustration" className="illustration" />
      <h2>Upload photos</h2>
      <p>After uploading photos, you can preview them here</p>
      <button onClick={openFileDialog} className="add-button">
        Add Photos
      </button>
    </div>
  );
}

export default UploadBox;
